"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var React = require("react");
var react_hot_toast_1 = require("react-hot-toast");
var react_query_1 = require("react-query");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var config_action_1 = require("../../../../actions/config_action");
var button_component_1 = require("../../../../common/buttons/button_component");
var drop_down_component_1 = require("../../../../common/drop_down/drop_down_component");
var pop_up_1 = require("../../../../common/modal/pop-up");
var react_paginate_1 = require("../../../../common/react_pagination/react_paginate");
var AGgrid_table_component_1 = require("../../../../common/tables/AGgrid_table_component");
var appConstants_1 = require("../../../../constants/appConstants");
var route_path_1 = require("../../../../constants/route_path");
var table_data_1 = require("../../../../constants/table_data");
var menu_constants_1 = require("../../../../menuList/menu_constants");
var array_helpers_1 = require("../../../../utils/array_helpers");
var reports_helper_1 = require("../reports_helper");
var text_field_with_datepicker_1 = require("../../../../common/text_filed/text_field_with_datepicker");
var EnchancedRLabtoPLabIntercityReport = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var LabcodeList = (0, react_redux_1.useSelector)(function (state) { return state.appConfigList.labList; });
    var _a = React.useState(undefined), dataList = _a[0], setDataList = _a[1];
    var _b = React.useState(''), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = React.useState(null), selectedRLab = _c[0], setSelectedRLab = _c[1];
    var _d = React.useState(null), selectedPLab = _d[0], setSelectedPLab = _d[1];
    var _e = React.useState(1), pageCount = _e[0], setpageCount = _e[1];
    var _f = React.useState(0), totalPageCount = _f[0], setTotalPageCount = _f[1];
    var _g = React.useState(appConstants_1.defaultPageLimit), PageLimit = _g[0], setPageLimit = _g[1];
    var _h = React.useState(0), totalCount = _h[0], setTotalCount = _h[1];
    var _j = React.useState(false), modelOpen = _j[0], setModalOpen = _j[1];
    var _k = React.useState(moment(new Date()).format('YYYY-MM-DD')), selectedDate = _k[0], setSelectedDate = _k[1];
    var _l = React.useState(false), filterButton = _l[0], setFilterbutton = _l[1];
    var rlabCodeChangeHandler = function (val) {
        setSelectedRLab(val);
    };
    var plabCodeChangeHandler = function (val) {
        setSelectedPLab(val);
    };
    var navigateToMyReports = function () {
        dispatch((0, config_action_1.featchCurrentActiveMenu)({
            mainModule: menu_constants_1.FEATURE_CONSTANTS.reports,
            subModule: menu_constants_1.FEATURE_CONSTANTS.sub_my_reports,
            subChaildModule: '',
            subGroupModule: ''
        }));
        navigate("/".concat(route_path_1.default.PATHS.reports, "/").concat(route_path_1.default.PATHS.MYREPORTS));
    };
    var handlePageClick = function (data) {
        var currentPage = data.selected + 1;
        setpageCount(currentPage);
    };
    var handlePageLimitChange = function (val) {
        setPageLimit(val);
    };
    var FilterHandler = function () {
        setFilterbutton(!filterButton);
    };
    var donwloadVisitHandlere = function () {
        var currentPage = pageCount < 1 ? 1 : pageCount;
        var payload = {};
        if (selectedDate !== null) {
            payload['date_range'] = {
                start_date: selectedDate,
                end_date: selectedDate,
            };
        }
        if (selectedRLab) {
            payload['r_lab_code'] = [selectedRLab.value];
        }
        if (selectedPLab) {
            payload['p_lab_code'] = [selectedPLab.value];
        }
        payload['report_mode'] = "enhanced";
        payload['limit'] = PageLimit ? parseInt(PageLimit.value.toString()) : 50;
        payload['page'] = currentPage;
        payload['size'] = PageLimit ? parseInt(PageLimit.value.toString()) : 50;
        (0, reports_helper_1.downloadRlabToPlabReports)(payload)
            .then(function (res) {
            if (res.statusCode === 200) {
                setModalOpen(true);
            }
            else {
                react_hot_toast_1.default.error(res.message);
            }
        })
            .catch(function (err) {
            react_hot_toast_1.default.error(err.message);
        });
    };
    var refetch = (0, react_query_1.useQuery)(['Rlab-Plab-enchanced', pageCount], function () {
        var currentPage = pageCount < 1 ? 1 : pageCount;
        var payload = {};
        if (selectedDate !== '') {
            payload['date_range'] = {
                start_date: selectedDate,
                end_date: selectedDate,
            };
        }
        if (selectedRLab) {
            payload['r_lab_code'] = [selectedRLab.value];
        }
        if (selectedPLab) {
            payload['p_lab_code'] = [selectedPLab.value];
        }
        payload['limit'] = PageLimit ? parseInt(PageLimit.value.toString()) : 50;
        payload['page'] = currentPage;
        payload['size'] = PageLimit ? parseInt(PageLimit.value.toString()) : 50;
        payload['report_mode'] = "enhanced";
        (0, reports_helper_1.RlabToPlabReports)(payload)
            .then(function (response) {
            var pageSize = PageLimit
                ? parseInt(PageLimit.value.toString())
                : 50;
            var count = Math.ceil(response.count / pageSize);
            setTotalPageCount(count);
            setTotalCount(response.count);
            setDataList(response.result);
        })
            .catch(function (err) {
            setErrorMessage(err);
            react_hot_toast_1.default.error(err);
            setDataList([]);
        });
    }).refetch;
    React.useEffect(function () {
        if (pageCount != 1) {
            setpageCount(1);
        }
        else {
            refetch();
        }
    }, [filterButton]);
    return (React.createElement("div", { className: "fe-wrapper pay  -fe-wrapper" },
        React.createElement("div", { className: "tool-bar-wrapper" },
            React.createElement("div", { className: "page-heaidng" },
                React.createElement("h2", null, "Rlab-Plab Shipment Report")),
            React.createElement(button_component_1.default, { type: "button", buttonName: appConstants_1.reportDownload, endIcon: "icon-import download-icon", color: "yellow-outline", onClickHandler: donwloadVisitHandlere, isError: !(dataList === null || dataList === void 0 ? void 0 : dataList.length) })),
        React.createElement("div", { className: "filter-menu-wrapper" },
            React.createElement("div", null),
            React.createElement("div", { className: "filter-options" },
                React.createElement(drop_down_component_1.default, { name: "rlab", placeholder: "Select R Lab", label: "R Lab Code", dropDownList: LabcodeList &&
                        (0, array_helpers_1.convertLabcodeResponse)(LabcodeList).sort(function (a, b) {
                            return a.label.localeCompare(b.label);
                        }), onChange: rlabCodeChangeHandler, value: selectedRLab, disableClearable: true }),
                React.createElement(drop_down_component_1.default, { name: "plab", placeholder: "Select P Lab", label: "P Lab Code", dropDownList: LabcodeList &&
                        (0, array_helpers_1.convertLabcodeResponse)(LabcodeList).sort(function (a, b) {
                            return a.label.localeCompare(b.label);
                        }), onChange: plabCodeChangeHandler, value: selectedPLab, disableClearable: true }),
                React.createElement(text_field_with_datepicker_1.default, { label: "Select Date", value: selectedDate, disableManulaEntry: true, onChange: function (dateValue) {
                        setSelectedDate(moment(dateValue).format('YYYY-MM-DD'));
                    }, isFutureDisable: false }),
                React.createElement(drop_down_component_1.default, { dropDownList: appConstants_1.paginationDropdown, onChange: handlePageLimitChange, value: PageLimit }),
                React.createElement(button_component_1.default, { buttonName: "FILTERS", color: "yellow-outline", onClickHandler: FilterHandler }))),
        React.createElement("div", { className: "unclickablerow custom-pagination-table" },
            React.createElement(AGgrid_table_component_1.default, { isSortable: true, columnDefs: table_data_1.default.RLABTOPLAB_ENCHANCED_REPORT_COLUMNS, rows: dataList, errorMessage: errorMessage, enableCellTextSelection: true, pagination: false, className: 'cash-collection-table' }),
            React.createElement(react_paginate_1.default, { onPageChange: handlePageClick, pageCount: totalPageCount, currentPage: pageCount, total: totalCount, dataLength: dataList === null || dataList === void 0 ? void 0 : dataList.length, currentPageLimits: PageLimit === null || PageLimit === void 0 ? void 0 : PageLimit.value })),
        React.createElement(pop_up_1.default, { open: modelOpen },
            React.createElement("div", { className: "modal-header" },
                React.createElement("h2", { className: "heading" }, "Request Submitted"),
                React.createElement("h2", { className: "sub-heading" }, "Please view your report in My Reports section")),
            React.createElement("div", { className: "modal-footer sticky-modal-footer" },
                React.createElement(button_component_1.default, { buttonName: "Cancel", color: "yellow-outline", isError: false, onClickHandler: function () { return setModalOpen(false); } }),
                React.createElement(button_component_1.default, { buttonName: "My Reports", color: "yellow", onClickHandler: navigateToMyReports, isError: false })))));
};
exports.default = EnchancedRLabtoPLabIntercityReport;
